import { MyProfileIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";
import { useNavigate } from "react-router-dom";
import { NumberBadge } from "../NumberBadge";

export const OpenWalletButton = ({
  isAuthenticated,
  loginFn,
  newPurchaseCounter,
}) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={async () => {
        if (!isAuthenticated) {
          await loginFn();
        }
        navigate(RoutePath.Wallet);
      }}
      aria-label="Open wallet"
      // NOTE: used in e2e tests — do not remove
      data-testid={isAuthenticated ? `open-wallet-button` : `login-button`}
    >
      <div className="relative flex gap-1">
        <MyProfileIcon className="w-5 h-5" />
        {newPurchaseCounter > 0 && (
          <div className="absolute -top-1 -right-1">
            <NumberBadge number={newPurchaseCounter} />
          </div>
        )}
      </div>
    </button>
  );
};
